import PropTypes from 'prop-types'

import './Card.scss'

export default function Card({children, title, className, p, m, style, ...props}) {

  const handleStyle = () => {
    const styleAttr = (style)? style : {}
    return {
      ...((m || m === 0)? {margin: m}: {}),
      ...((p || p === 0)? {padding: p}: {}),
      ...styleAttr,
    }
  }

  return (
    <div className={`tw-card ${className ? className : ''}`} {...props} style={handleStyle()}>
      <div className="tw-card-title"> {title }</div>
      <div className="tw-card-body">
        {children}
      </div>
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  m: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  p: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  className: PropTypes.string
}